import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

interface CaptionRowProps {
  text: string;
  style: {
    theme: string;
    entrance: "scalePerWord" | "static";
    position?: string;
    textStroke?: string;
    backgroundColor?: string;
    paddingBottom?: string;
  };
}

const CaptionRow: React.FC<CaptionRowProps> = ({ text, style }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // ── 静态字幕：逐字不跳动，直接全部显示 ──
  if (style.entrance === "static") {
    return (
      <AbsoluteFill
        style={{
          justifyContent: "flex-end",
          alignItems: "center",
          paddingBottom: style.paddingBottom || "15%",
        }}
      >
        {/* 底部黑底条 - 全宽 */}
        <div
          style={{
            width: "100%",
            padding: "16px 0",
            backgroundColor: style.backgroundColor || "transparent",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 4,
              maxWidth: "90%",
            }}
          >
            <span
              style={{
                fontSize: style.position === "bottom" ? 40 : 56,
                fontWeight: 700,
                fontFamily: "sans-serif",
                color: style.theme,
                WebkitTextStroke: style.textStroke || "none",
              }}
            >
              {text}
            </span>
          </div>
        </div>
      </AbsoluteFill>
    );
  }

  const words = text.split("");
  const staggerFrames = 2; // 每个字间隔 2 帧

  return (
    <AbsoluteFill
      style={{
        justifyContent: "flex-end",
        alignItems: "center",
        paddingBottom: style.paddingBottom || "15%",
      }}
    >
      {/* 底部黑底条 - 全宽 */}
      <div
        style={{
          width: "100%",
          padding: "16px 0",
          backgroundColor: style.backgroundColor || "transparent",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 4,
            maxWidth: "90%",
          }}
      >
        {words.map((char, i) => {
          const localFrame = Math.max(0, frame - i * staggerFrames);
          if (localFrame === 0 && frame < i * staggerFrames) {
            return (
              <span
                key={i}
                style={{
                  fontSize: style.position === "bottom" ? 40 : 56,
                  fontWeight: 700,
                  fontFamily: "sans-serif",
                  color: style.theme,
                  WebkitTextStroke: style.textStroke || "4px black",
                  opacity: 0,
                  transform: "scale(0)",
                }}
              >
                {char}
              </span>
            );
          }

          const progress = spring({
            frame: localFrame,
            fps,
            config: { damping: 10, mass: 0.5, stiffness: 200 },
            durationInFrames: 10,
          });

          const opacity = interpolate(progress, [0, 0.3, 1], [0, 1, 1]);
          const scale = interpolate(progress, [0, 0.6, 1], [0, 1.3, 1]);

          return (
            <span
              key={i}
              style={{
                fontSize: style.position === "bottom" ? 40 : 56,
                fontWeight: 700,
                fontFamily: "sans-serif",
                color: style.theme,
                WebkitTextStroke: style.textStroke || "4px black",
                opacity,
                transform: `scale(${scale})`,
                display: "inline-block",
              }}
            >
              {char === " " ? " " : char}
            </span>
          );
        })}
      </div>
      </div>
    </AbsoluteFill>
  );
};

export default CaptionRow;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
